import { render, staticRenderFns } from "./BillingPage.vue?vue&type=template&id=3fd25cc1&scoped=true"
import script from "./BillingPage.vue?vue&type=script&lang=js"
export * from "./BillingPage.vue?vue&type=script&lang=js"
import style0 from "./BillingPage.vue?vue&type=style&index=0&id=3fd25cc1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd25cc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd25cc1')) {
      api.createRecord('3fd25cc1', component.options)
    } else {
      api.reload('3fd25cc1', component.options)
    }
    module.hot.accept("./BillingPage.vue?vue&type=template&id=3fd25cc1&scoped=true", function () {
      api.rerender('3fd25cc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Billing/Pages/BillingPage.vue"
export default component.exports